import axios from "axios";
import React, {useEffect, useState,useRef} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import { render } from "react-dom";
import clientconfigwebapp, {
    empty_bk,
    convert_to_english_strhk,
    scrollTo_uphk,
    check_login_appbk,
    Token_get_appbk,
    redirectbh_typeb,
    FormatNumberByhkh,
    Cart_get_list_product,
} from '../../clientconfigwebapp';
import { ToastContainer, toast } from 'react-toastify';

import Master_Front from "../../pages/Master_Front";

import "../../components/assets/css/profile.css"
import "../../assets/css/account.css";

import ReactFullPageLoadinghk from "../../components/layaout/LoadingFullpagehk";
import Menu_panel from "../../components/layaout/Menu-panel";

import Grid from '@mui/material/Grid';
import {Button} from "@mui/material";
import LazyLoad from "react-lazy-load";
import banner from "../../assets/img/Rectangle 305.png";



const serialize = require('form-serialize');


const Wallet = () => {

    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile,setData_first_name_profile] = useState('');
    const [last_name_profile,setData_last_name_profile] = useState('');
    const [list_order_get,setData_list_order] = useState([]);
    /*  end profile */

    const [wallet_input, setData_wallet_input] = useState('0');


    const tagHandler = (event) => {
        const spans = document.querySelectorAll('#charge-span');
        spans.forEach(span => {
            span.classList.remove('active-span');
        })
        event.target.classList.add('active-span');



    }



    useEffect(() => {
        scrollTo_uphk();
        if(check_login_appbk()==false){
           redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );
            return false;
        }
        Load_api_page();

    }, [location_get_urlbk]);

    const Load_api_page= () => {

        if(check_login_appbk()==false){ redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );} ////dddddd

        const config = {
            headers: { Authorization: `Bearer ${Token_get_appbk()}` }
        };

        Setloadinghkfullshow("true");


        axios.post(`${clientconfigwebapp.siteurl}api/v1/dashboard-get`,null,config)
            .then((res) => {
 Setloadinghkfullshow("false");
                if(String(res.data).length > 0) {

                    if(String(res.data.data)=="login-show"){ redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login" );  } ////dddddd

                    if(String(res.data.wallet_inventory).length > 0) {  setData_wallet_balance(res.data.wallet_inventory); }
                    if (!empty_bk(res.data.first_name_profile)) { setData_first_name_profile(res.data.first_name_profile); localStorage.setItem('first_name_Get',res.data.first_name_profile);    }
                    if (!empty_bk(res.data.last_name_profile)) { setData_last_name_profile(res.data.last_name_profile); localStorage.setItem('last_name_Get',res.data.last_name_profile);    }


                  ///  if(String(res.data.data.total_cource_order).length  > 0) {  setData_total_cource_order(res.data.data.total_cource_order); }
                 if(String(res.data.data.list_order).length > 0) {  setData_list_order(res.data.data.list_order); }







                }else{
                    if(String(res.data.msgwebapp).length > 0)  toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                }

            }).catch((err) =>{
             Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 435346', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        });





    }

    const wallet_input_Handler=(event)=>{
        setData_wallet_input(convert_to_english_strhk(event.target.value));



    }

    const send_wallet_pay= () => {




        return   toast.error('شارژ کیف پول باید به درگاه بانکی وصل شود(درگاه باید تهیه کنید).', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
        if(empty_bk(wallet_input)){

            toast.error('مبلغ شارژ کیف پول انتخاب نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});

        }else{


            if(wallet_input=="0" || wallet_input==0 ){
                toast.error('مبلغ شارژ کیف پول انتخاب نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});

            }else{
                var url_Get=  clientconfigwebapp.webappurl + "checkout-wallet/" + String(wallet_input);
                var form = document.createElement("form");
                form.setAttribute("method", "GET");
                form.setAttribute("action",url_Get  );
                form.setAttribute("target", "_self");

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);


            }




        }

    }

    return (
        <>
            <Master_Front   wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} >
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}  />
                <ToastContainer />


                <img src={banner} alt="banner" className='baner-panel'/>

                <section className='w-100 flexRowBetStart account-section-container'>




                    <Grid container direction="row" spacing={2} style={{paddingTop:"14px"}}>


                        <Grid  item className="item_inputbk" lg={3} md={3} sm={12} xs={12} style={{marginTop:"4px"}}>


                            <div className='account-aside'>
                                <Menu_panel wallet_balance={wallet_balance} first_name_profile={first_name_profile} last_name_profile={last_name_profile} />
                            </div>

                        </Grid>


                        <Grid  item className="item_inputbk" lg={9} md={9} sm={12} xs={12} style={{marginTop:"4px"}}>

                            <section className='account-content wallet-price-tag'>

                                <div className={"title_page_panel"} style={{width: '100%',"marginBottom":"0px", paddingBottom: '0px', display: 'flex', flexFlow: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                                    <div ><span style={{"color":"var(--c7)","fontFamily":"iran","fontSize":"19px","fontStyle":"normal","fontWeight":"700","lineHeight":"normal","paddingTop":"35px","display":"block","paddingBottom":"28px"}}>کیف پول</span></div>
                                    <div ><span style={{"color":"var(--c7)","fontFamily":"iran","fontSize":"19px","fontStyle":"normal","fontWeight":"700","lineHeight":"normal","paddingTop":"35px","display":"block","paddingBottom":"28px"}}> موجودی :  {FormatNumberByhkh(String(wallet_balance), ".", ",","t")} </span></div>
                                </div>



                                <div style={{"backgroundColor":"#fbfbfb","padding":"10px","borderRadius":"10px","paddingTop":"33px","paddingBottom":"33px"}}>
                                    <div style={{"textAlign":"center","fontSize":"17px","fontFamily":"'iran'","paddingBottom":"18px",color:"var(--c2)"}}>مبلغ مورد نظر خود را مشخص و از طریق درگاه بانکی حسابتان را شارژ کنید</div>
                                    <div className='flexRowCenterCenter'>
                                        <span id='charge-span' onClick={tagHandler}>100،000</span>
                                        <span id='charge-span' onClick={tagHandler}>200،000</span>
                                        <span id='charge-span' onClick={tagHandler}>300،000</span>
                                        <span id='charge-span' onClick={tagHandler}>400،000</span>
                                        <span id='charge-span' onClick={tagHandler}>500،000</span>
                                    </div>


                                    <div className={"input_box_wallet"}>

                                        <input id={"input_wallet"} type="text" placeholder="مبلغ شارژ(تومان)" style={{"fontFamily":"'iran'","width":"281px","height":"37px","border":"solid 1px #d9d0d0","marginTop":"10px"}}  onChange={wallet_input_Handler}  />

                                    </div>


                                    <div style={{"textAlign":"center"}}>

                                        <button type={"button"}  onClick={send_wallet_pay}  className='button-wallet-charche'>شارژ کیف پول</button>
                                    </div>

                                </div>


                            </section>


                        </Grid>






                    </Grid>






                </section>










            </Master_Front>

        </>
    );
}


export default Wallet;